import {DataTable} from 'pepsico-ds'

const columns = [
  {columnKey: 'Description', header: 'Description'},
  {columnKey: 'PointsAwarded', header: 'Points Awarded'},
  {columnKey: 'StartDate', header: 'Start Date'},
  {columnKey: 'EndDate', header: 'End Date'},
  {columnKey: 'Status', header: 'Status'},
]

const tableData = [
  {
    Description: 'Sales Target Name',
    PointsAwarded: '250',
    StartDate: '2024-10-27 ',
    EndDate: '2024-11-18',
    Status: 'Active',
  },
  {
    Description: 'Sales Target Name',
    PointsAwarded: '250',
    StartDate: '2024-10-27 ',
    EndDate: '2024-11-18',
    Status: 'Completed',
  },
  {
    Description: 'Sales Target Name',
    PointsAwarded: '250',
    StartDate: '2024-10-27 ',
    EndDate: '2024-11-18',
    Status: 'Completed',
  },
  {
    Description: 'Sales Target Name',
    PointsAwarded: '250',
    StartDate: '2024-10-27 ',
    EndDate: '2024-11-18',
    Status: 'Completed',
  },
]

const filters = [
  {
    disabled: false,
    label: 'Status',
    //listLabel: 'Header',
    onChange: () => {},
    options: [
      {id: '1', label: 'Active'},
      {id: '3', label: 'Completed'},
    ],
  },
]

const SalesTarget = () => {
  return (
    <DataTable
      columns={columns}
      data={tableData}
      isDark={true}
      isExpandable={false}
      pageIndex={0}
      pageSize={10}
      selection="single"
      size="large"
      tableHeader=""
      tableDescription=""
      filters={filters}
      toolbarActions={[
        {
          text: 'Download',
          variant: 'secondary',
          onClick: () => alert('Download button clicked'),
        },
      ]}
    />
  )
}

export default SalesTarget
